module.exports = __webpack_public_path__ + "img/168193.a08de68c.jpg";